/* ============================================================
   REVIEWS / SOCIAL PROOF — vanilla JS, no dependencies
   File: assets/reviews.js
   ============================================================ */

(function () {
  function init(section) {
    const track = section.querySelector('[data-rev-track]');
    const cards = Array.from(section.querySelectorAll('[data-rev-card]'));
    const prev  = section.querySelector('[data-rev-prev]');
    const next  = section.querySelector('[data-rev-next]');
    const dotsContainer = section.querySelector('[data-rev-dots]');
    if (!track || cards.length === 0) return;

    dotsContainer.innerHTML = '';
    cards.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Bewertung ' + (i + 1));
      b.addEventListener('click', () => scrollToIndex(i));
      dotsContainer.appendChild(b);
    });
    const dots = Array.from(dotsContainer.children);

    function update() {
      const cardWidth = cards[0]?.offsetWidth || 0;
      const idx = Math.round(track.scrollLeft / cardWidth);
      dots.forEach((d, i) => d.setAttribute('data-active', i === idx ? 'true' : 'false'));
    }

    function scrollToIndex(i) {
      const cardWidth = cards[0]?.offsetWidth || 0;
      track.scrollTo({ left: i * cardWidth, behavior: 'smooth' });
    }
    function step(dir) {
      const cardWidth = cards[0]?.offsetWidth || 0;
      track.scrollBy({ left: dir * cardWidth, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);

    update();
  }

  function initAll() {
    document.querySelectorAll('.rev-section').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (e) => {
    const sec = e.target.querySelector('.rev-section');
    if (sec) init(sec);
  });
})();
